export const ENDPOINTS = {
  // Public (no auth)
  public: {
    login: '/public/login',
    signup: '/public/signup',
    forgotPassword: '/public/forgot-password',
    resetPassword: '/public/reset-password',
    pricing: '/public/pricing',
    health: '/public/health',
  },

  // Auth (requires token)
  auth: {
    me: '/auth/me',
    update: '/auth/me',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    changePassword: '/auth/change-password',
  },

  // Dashboard
  dashboard: {
    kpis: '/dashboard/kpis',
    trends: '/dashboard/trends',
    revenue: '/dashboard/revenue',
    orders: '/dashboard/orders',
    channels: '/dashboard/channels',
    topProducts: '/dashboard/top-products',
    topChannels: '/dashboard/top-channels',
    geo: '/dashboard/geo',
    rfmSummary: '/analytics/rfm',
  },

  // Analytics
  analytics: {
    model: '/analytics/model',
    query: '/analytics/query',
    channels: '/analytics/channels',
    warehouses: '/analytics/warehouses',
    sales: '/analytics/sales',
    products: '/analytics/products',
    geography: '/analytics/geography',
    customers: '/analytics/customers',
    brands: '/analytics/brands',
    categories: '/analytics/categories',
    compare: '/analytics/compare',
    export: '/analytics/export',
    // E-Commerce Advanced
    rfm: '/analytics/rfm',
    clv: '/analytics/clv',
    inventory: '/analytics/inventory',
    supplierOrders: '/analytics/supplier-orders',
    orders: '/analytics/orders',
    fulfillment: '/analytics/fulfillment',
    pnl: '/analytics/pnl',
    seasonality: '/analytics/seasonality',
    smartReorder: '/analytics/smart-reorder',
    suppliers: '/analytics/suppliers',
    // SaaS
    mrr: '/analytics/mrr',
    churn: '/analytics/churn',
    cac: '/analytics/cac',
    ltv: '/analytics/ltv',
    unitEconomics: '/analytics/unit-economics',
    trialConversion: '/analytics/trial-conversion',
    // Restaurant
    service: '/analytics/service',
    menu: '/analytics/menu',
    laborCost: '/analytics/labor-cost',
    recipeProfitability: '/analytics/recipe-profitability',
    // Logistics
    deliveries: '/analytics/deliveries',
    fleet: '/analytics/fleet',
    driverPerformance: '/analytics/driver-performance',
    customerSatisfaction: '/analytics/customer-satisfaction',
    // Healthcare
    appointments: '/analytics/appointments',
    patients: '/analytics/patients',
    treatments: '/analytics/treatments',
    // Fitness
    memberships: '/analytics/memberships',
    attendance: '/analytics/attendance',
    classes: '/analytics/classes',
    // Hotel
    occupancy: '/analytics/occupancy',
    bookings: '/analytics/bookings',
    revpar: '/analytics/revpar',
    // Manufacturing
    production: '/analytics/production',
    oee: '/analytics/oee',
    defects: '/analytics/defects',
    // Sales Agent
    customersMap: '/analytics/customers-map',
    territory: '/analytics/territory',
    // Resource detail (drill-down)
    detail: '/analytics/detail',
    search: '/analytics/search',
    globalSearch: '/analytics/global-search',
    // Generic catalog (paginated browse)
    catalog: '/analytics/catalog',
  },

  // Users
  users: {
    list: '/users',
    create: '/users',
    stats: '/users/stats',
    detail: (id: string) => `/users/${id}`,
    update: (id: string) => `/users/${id}`,
    delete: (id: string) => `/users/${id}`,
    acceptInvite: '/users/accept-invite',
    invitations: {
      resend: (id: string) => `/users/invitations/${id}/resend`,
      cancel: (id: string) => `/users/invitations/${id}`,
    },
  },

  // Connectors (super_admin only)
  connectors: {
    list: '/connectors',
    create: '/connectors',
    detail: (id: string) => `/connectors/${id}`,
    update: (id: string) => `/connectors/${id}`,
    delete: (id: string) => `/connectors/${id}`,
    test: (id: string) => `/connectors/${id}/test`,
    // Upload
    upload: '/connectors/upload',
    uploadConfirm: (uploadId: string) => `/connectors/upload/${uploadId}/confirm`,
    uploadStatus: (uploadId: string) => `/connectors/upload/${uploadId}`,
  },

  // Jobs (super_admin only)
  jobs: {
    list: '/jobs',
    create: '/jobs',
    detail: (id: string) => `/jobs/${id}`,
    update: (id: string) => `/jobs/${id}`,
    delete: (id: string) => `/jobs/${id}`,
    run: (id: string) => `/jobs/${id}/run`,
    runs: (id: string) => `/jobs/${id}/runs`,
  },

  // Tenant
  tenant: {
    list: '/tenants',
    detail: (id: string) => `/tenants/${id}`,
    update: (id: string) => `/tenants/${id}`,
    settings: (id: string) => `/tenants/${id}/settings`,
    usage: (id: string) => `/tenants/${id}/usage`,
  },
} as const
